import React from "react";
import RadioInput from "./RadioInput";

export function radioListCreator(arr = [], func) {
    const sub = []
    arr.forEach((radio) => {
        sub.push(
            <RadioInput
                name={radio.name}
                keys={radio.value}
                value={radio.value}
                title={radio.title}
                subModel={radio.child}
                onChange={func}
                checked={radio.checked}
            />
        )
    })
    return sub
}